<template>
	<div class="app-container">
		<!-- 搜索过滤 -->
		<el-card class="filter-card">
			<el-form :inline="true" :model="filterForm" class="filter-form">
				<el-form-item>
					<el-button type="primary" @click="handleAdd">
						<el-icon>
							<Plus />
						</el-icon> 新建用户
					</el-button>
				</el-form-item>
				<el-form-item>
					<el-divider direction="vertical"></el-divider>
				</el-form-item>
				<el-form-item label="用户名">
					<el-input v-model="filterForm.username" placeholder="请输入用户名" clearable
						@keyup.enter="handleSearch" />
				</el-form-item>
				<!-- <el-form-item label="姓名">
          <el-input v-model="filterForm.name" placeholder="请输入姓名" clearable @keyup.enter="handleSearch" />
        </el-form-item> -->
				<el-form-item label="手机号">
					<el-input v-model="filterForm.mobile" placeholder="请输入手机号" clearable @keyup.enter="handleSearch" />
				</el-form-item>
				<!-- <el-form-item label="状态">
          <el-select v-model="filterForm.status" placeholder="请选择状态" clearable>
            <el-option label="启用" :value="1" />
            <el-option label="禁用" :value="0" />
          </el-select>
        </el-form-item> -->
				<el-form-item>
					<el-button type="primary" @click="handleSearch">
						<el-icon>
							<Search />
						</el-icon> 搜索
					</el-button>
					<el-button @click="resetForm">
						<el-icon>
							<Refresh />
						</el-icon> 重置
					</el-button>
				</el-form-item>
			</el-form>
		</el-card>

		<!-- 用户列表 -->
		<el-card class="table-card">
			<el-table :data="userList" style="width: 100%" v-loading="loading">
				<el-table-column type="index" label="序号" width="60" />
				<el-table-column prop="username" label="用户名" />
				<!-- <el-table-column prop="realName" label="姓名" /> -->
				<el-table-column prop="mobile" label="手机号" />
				<el-table-column prop="email" label="邮箱" />
				<el-table-column prop="deptName" label="部门" />
				<el-table-column prop="position" label="职位" />
				<el-table-column prop="isActive" label="状态" width="100">
					<template #default="scope">
						<el-tag :type="scope.row.isActive === 1 ? 'success' : 'danger'">
							{{ scope.row.isActive === 1 ? '正常' : '已禁用' }}
						</el-tag>
					</template>
				</el-table-column>
				<!-- <el-table-column prop="createTime" label="创建时间" width="180">
          <template #default="scope">
            {{ formatDateTime(scope.row.createTime) }}
          </template>
        </el-table-column> -->
				<el-table-column label="操作" width="220" fixed="right">
					<template #default="scope">
						<el-button size="small" type="warning" @click="handleView(scope.row)">查看</el-button>
						<el-button size="small" type="primary" @click="handleEdit(scope.row)">编辑</el-button>
						<el-button size="small" type="danger" @click="handleDelete(scope.row)">删除</el-button>
						<!-- <el-button 
              size="mini" 
              :type="scope.row.status === 1 ? 'danger' : 'success'"
              @click="handleToggleStatus(scope.row)">
              {{ scope.row.status === 1 ? '禁用' : '启用' }}
            </el-button> -->
					</template>
				</el-table-column>
			</el-table>

			<div class="pagination-container">
				<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
					:current-page="currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize"
					layout="total, sizes, prev, pager, next, jumper" :total="total">
				</el-pagination>
			</div>
		</el-card>

		<!-- 新建/编辑用户对话框 -->
		<el-dialog :title="dialogTitle" v-model="dialogVisible" width="600px" :close-on-click-modal="false"
			:close-on-press-escape="false" destroy-on-close>
			<el-form :model="userForm" :rules="rules" ref="userForm" label-width="100px" v-loading="dialogLoading">
				<el-form-item label="用户名" prop="username">
					<el-input v-model="userForm.username" placeholder="请输入用户名" :disabled="!!userForm.id" />
				</el-form-item>
				<!-- <el-form-item label="姓名" prop="realName">
          <el-input v-model="userForm.realName" placeholder="请输入姓名" />
        </el-form-item> -->
				<el-form-item label="手机号" prop="mobile">
					<el-input v-model="userForm.mobile" placeholder="请输入手机号" />
				</el-form-item>
				<el-form-item label="邮箱" prop="email">
					<el-input v-model="userForm.email" placeholder="请输入邮箱" />
				</el-form-item>
				<el-form-item label="部门" prop="department">
					<el-tree-select v-model="userForm.deptId" :data="departmentTree"
						:props="{ value: 'deptId', label: 'deptName' }" placeholder="请选择部门" check-strictly
						:render-after-expand="false" @change="handleDepartmentChange" />
				</el-form-item>
				<el-form-item label="职位" prop="position">
					<el-input v-model="userForm.position" placeholder="请输入职位" />
				</el-form-item>
				<el-form-item label="密码" prop="password" v-if="!userForm.id">
					<el-input v-model="userForm.password" type="password" placeholder="请输入密码" show-password />
				</el-form-item>
				<el-form-item label="确认密码" prop="confirmPassword" v-if="!userForm.id">
					<el-input v-model="userForm.confirmPassword" type="password" placeholder="请确认密码" show-password />
				</el-form-item>
				<!-- <el-form-item label="状态" prop="status">
          <el-radio-group v-model="userForm.status">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="0">禁用</el-radio>
          </el-radio-group>
        </el-form-item> -->
				<!-- <el-form-item label="备注" prop="remark">
          <el-input 
            v-model="userForm.remark" 
            type="textarea" 
            :rows="2"
            placeholder="请输入备注说明" />
        </el-form-item> -->
			</el-form>
			<template #footer>
				<span class="dialog-footer">
					<el-button @click="dialogVisible = false">取 消</el-button>
					<el-button type="primary" @click="submitForm" :loading="submitLoading">
						确 定
					</el-button>
				</span>
			</template>
		</el-dialog>

		<!-- 查看用户详情对话框 -->
		<el-dialog title="用户详情" v-model="viewDialogVisible" width="600px">
			<el-descriptions :column="2" border>
				<el-descriptions-item label="用户名">{{ viewUser.username }}</el-descriptions-item>
				<!-- <el-descriptions-item label="姓名">{{ viewUser.realName }}</el-descriptions-item> -->
				<el-descriptions-item label="手机号">{{ viewUser.mobile }}</el-descriptions-item>
				<el-descriptions-item label="邮箱">{{ viewUser.email }}</el-descriptions-item>
				<el-descriptions-item label="部门">{{ viewUser.deptName }}</el-descriptions-item>
				<el-descriptions-item label="职位">{{ viewUser.position }}</el-descriptions-item>
				<!-- <el-descriptions-item label="状态">
          <el-tag :type="viewUser.status === 1 ? 'success' : 'danger'">
            {{ viewUser.status === 1 ? '启用' : '禁用' }}
          </el-tag>
        </el-descriptions-item> -->
				<el-descriptions-item label="创建时间">{{ formatDateTime(viewUser.createTime) }}</el-descriptions-item>
				<!-- <el-descriptions-item label="备注" :span="2">{{ viewUser.remark || '无' }}</el-descriptions-item> -->
			</el-descriptions>
		</el-dialog>
	</div>
</template>

<script>
	import {
		Plus,
		Search,
		Refresh
	} from '@element-plus/icons-vue'
	import {
		ElMessage,
		ElMessageBox
	} from 'element-plus'
	import dayjs from 'dayjs'
	import {
		getUserList,
		createUser,
		updateUser,
		toggleUserStatus,
		deleteUser
	} from '@/api/user'
	import {
		getDepartmentTree
	} from '@/api/department'

	export default {
		name: 'UserManagement',
		components: {
			Plus,
			Search,
			Refresh
		},
		data() {
			// 密码确认验证
			const validateConfirmPassword = (rule, value, callback) => {
				if (value !== this.userForm.password) {
					callback(new Error('两次输入的密码不一致'))
				} else {
					callback()
				}
			}
			return {
				loading: false,
				dialogLoading: false,
				submitLoading: false,
				filterForm: {
					username: '',
					realName: '',
					mobile: '',
					status: ''
				},
				userList: [],
				currentPage: 1,
				pageSize: 10,
				total: 0,
				dialogVisible: false,
				viewDialogVisible: false,
				dialogTitle: '新建用户',
				viewUser: {},
				departmentTree: [],
				userForm: {
					username: '',
					realName: '',
					mobile: '',
					email: '',
					deptId: null,
					deptName: '',
					position: '',
					password: '',
					confirmPassword: '',
					status: 1,
					remark: ''
				},
				rules: {
					username: [{
							required: true,
							message: '请输入用户名',
							trigger: 'blur'
						},
						{
							min: 3,
							max: 20,
							message: '长度在 3 到 20 个字符',
							trigger: 'blur'
						}
					],
					realName: [{
						required: true,
						message: '请输入姓名',
						trigger: 'blur'
					}],
					mobile: [{
							required: true,
							message: '请输入手机号',
							trigger: 'blur'
						},
						{
							pattern: /^1[3-9]\d{9}$/,
							message: '请输入正确的手机号',
							trigger: 'blur'
						}
					],
					email: [{
						type: 'email',
						message: '请输入正确的邮箱地址',
						trigger: 'blur'
					}],
					password: [{
							required: true,
							message: '请输入密码',
							trigger: 'blur'
						},
						{
							min: 6,
							message: '密码长度不能小于6位',
							trigger: 'blur'
						}
					],
					confirmPassword: [{
							required: true,
							message: '请确认密码',
							trigger: 'blur'
						},
						{
							validator: validateConfirmPassword,
							trigger: 'blur'
						}
					],
					status: [{
						required: true,
						message: '请选择状态',
						trigger: 'change'
					}]
				}
			}
		},
		created() {
			this.fetchData()
			this.fetchDepartmentTree()
		},
		methods: {
			formatDateTime(date) {
				if (!date) return ''
				return dayjs(date).format('YYYY-MM-DD HH:mm:ss')
			},
			async fetchData() {
				this.loading = true
				try {
					const params = {
						current: this.currentPage,
						size: this.pageSize,
						...this.filterForm
					}
					const res = await getUserList(params)
					this.userList = res.data.records
					this.total = res.data.total
				} catch (error) {
					console.error('获取用户列表失败:', error)
					ElMessage.error('获取用户列表失败')
				} finally {
					this.loading = false
				}
			},
			handleSearch() {
				this.currentPage = 1
				this.fetchData()
			},
			resetForm() {
				this.filterForm = {
					username: '',
					realName: '',
					phone: '',
					status: ''
				}
				this.handleSearch()
			},
			handleSizeChange(val) {
				this.pageSize = val
				this.fetchData()
			},
			handleCurrentChange(val) {
				this.currentPage = val
				this.fetchData()
			},
			async fetchDepartmentTree() {
				try {
					const res = await getDepartmentTree()
					this.departmentTree = res.data
				} catch (error) {
					console.error('获取部门树形数据失败:', error)
					ElMessage.error('获取部门树形数据失败')
				}
			},
			handleDepartmentChange(value) {
				const department = this.departmentTree.find(dept => dept.deptId === value)
				if (department) {
					this.userForm.deptName = department.deptName
				}
			},
			handleAdd() {
				this.dialogTitle = '新建用户'
				this.userForm = {
					username: '',
					realName: '',
					phone: '',
					email: '',
					deptId: null,
					deptName: '',
					position: '',
					password: '',
					confirmPassword: '',
					status: 1,
					remark: ''
				}
				this.dialogVisible = true
			},
			handleEdit(row) {
				// this.$router.push(`/user/detail/${row.id}`)

				this.dialogTitle = '编辑用户'
				this.userForm = {
					...row
				}
				this.dialogVisible = true
			},
			handleDelete(row) {
				// this.$router.push(`/user/detail/${row.id}`)
				ElMessageBox.confirm('确认删除该用户吗？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(async () => {
					try {
						await deleteUser({
							id: row.id
						})
						ElMessage.success('删除成功')
						this.fetchData()
					} catch (error) {
						console.error('删除用户失败:', error)
						ElMessage.error('删除失败')
					}
				}).catch(() => {})
			},
			handleView(row) {
				this.viewUser = {
					...row
				}
				this.viewDialogVisible = true
			},
			handleToggleStatus(row) {
				const action = row.status === 1 ? '禁用' : '启用'
				ElMessageBox.confirm(`确认${action}该用户吗？`, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(async () => {
					try {
						await toggleUserStatus(row.id)
						ElMessage.success(`${action}成功`)
						this.fetchData()
					} catch (error) {
						console.error(`${action}用户失败:`, error)
						ElMessage.error(`${action}失败`)
					}
				}).catch(() => {})
			},
			async submitForm() {
				try {
					await this.$refs.userForm.validate()
					this.submitLoading = true

					if (this.userForm.id) {
						await updateUser(this.userForm)
						ElMessage.success('更新成功')
					} else {
						await createUser(this.userForm)
						ElMessage.success('创建成功')
					}
					this.dialogVisible = false
					this.fetchData()
				} catch (error) {
					if (error.message) {
						ElMessage.error(error.message)
					}
					console.error('提交表单失败:', error)
				} finally {
					this.submitLoading = false
				}
			}
		}
	}
</script>

<style scoped>
	.user-management {
		/* padding: 20px; */
	}

	.page-header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 10px;
	}

	.header-actions {
		display: flex;
		gap: 10px;
	}

	.filter-card {
		margin-bottom: 20px;
	}

	.filter-form {
		display: flex;
		flex-wrap: wrap;
		gap: 10px;
	}

	.table-card {
		margin-bottom: 20px;
	}

	.pagination-container {
		margin-top: 20px;
		text-align: right;
	}

	.el-dialog {
		display: flex;
		flex-direction: column;
		margin: 0 !important;
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		max-height: calc(100vh - 30px);
		max-width: calc(100vw - 30px);
	}

	.el-dialog__body {
		flex: 1;
		overflow: auto;
		padding: 20px;
	}
</style>